import React from 'react'
import { Box, styled, Typography } from "@mui/material";

function ReportFooter() {
  return (
    <SectionWrap component="section" sx={{ position: "relative" }}>
            <ContainerWrap>
                <RowWrap>
                    <Col12Wrap>
                        <CustomHead component="h2" id="FooterTitle">People Powered. Data Driven. Results Realized.</CustomHead>
                        <CustomText id="RolerevirContent">
                        <span id="forMoreInfo">For more information,</span>
                            <EmailLink href="mailto:info@activatehcg.com">info@activatehcg.com</EmailLink>
                            <span id="contactOrVisit">contact or visit our website </span>
                            <WebsiteLink href="https://www.activatehcg.com/" target="_blank">ActivateHCG.com</WebsiteLink>
                        </CustomText>
                    </Col12Wrap>
                </RowWrap>
            </ContainerWrap>
        </SectionWrap>
  )
}

export default ReportFooter

const SectionWrap = styled(Box)(() => ({
 
    padding: "25px 0",
 
    background: "#1085AB",
  }));
  const ContainerWrap = styled(Box)(() => ({
    width: "100%",
    maxWidth: "1170px",
    paddingLeft: "15px",
    paddingRight: "15px",
    marginLeft: "auto",
    marginRight: "auto",
  }));
  const RowWrap = styled(Box)(() => ({
    display: "flex",
    flexWrap: "wrap",
    marginLeft: "-15px",
    marginRight: "-15px",
  }));
  const Col12Wrap = styled(Box)(() => ({
    flex: "0 0 auto",
    width: "100%",
    maxWidth: "100%",
    paddingLeft: "15px",
    paddingRight: "15px",
  }));
  const CustomHead = styled(Typography)(() => ({
    fontSize: "27px",
    fontWeight: "600",
    lineHeight: "1.2",
    color: "#FFFFFF",
    textAlign: "center",
    marginBottom: "5px",
    "@media (max-width: 575px)": {
      fontSize: "22px",
    },
  }));
  const CustomText = styled(Typography)(() => ({
    fontSize: "20px",
    fontWeight: "400",
    lineHeight: "1.5",
    color: "#FFFFFF",
    
    textAlign: "center",
    "& .MuiLink-root": {
        color: "#FFFFFF",
        textDecoration: "underline",
    },
    "@media (max-width: 575px)": {
      fontSize: "20px",
    },
  }));
  const EmailLink = styled('a')(() => ({  // Use standard <a> tag
    color: "#FFFFFF",
    textDecoration: "underline",
    marginRight: '5px',
}));

const WebsiteLink = styled('a')(() => ({  // Use standard <a> tag
    color: "#FFFFFF",
    textDecoration: "underline",
    
}));

